import jump from 'jump.js';
import { pushToDataLayerDirectly } from '@/ui/scripts/analytics/analytics.methods';

const featuredUpdates = [...document.getElementsByClassName('js-featured-update-card__action')];

function clickHandler(event) {
  event.preventDefault();
  const targetElement = document.getElementById(event.target.hash.substring(1));
  if (targetElement !== null) {
    if (targetElement.checkVisibility() === false) {
      targetElement
        .closest('.js-accordion-item')
        .getElementsByClassName('js-accordion-trigger')[0]
        .click();
    }
    jump(targetElement, {
      a11y: true,
      duration: 1200,
      offset: -100,
    });
  }
  pushToDataLayerDirectly({
    event: 'project_page_featured_updates_click',
    link_text: event.target.innerText.trim(),
    link_url: event.target.href,
    element_title: event.target
      .closest('.c-featured-update-card__content-wrapper')
      .getElementsByClassName('c-featured-update-card__title')[0].innerText,
  });
}

function init() {
  featuredUpdates.forEach((action) => action.addEventListener('click', clickHandler));
}

export default init;
